import { recheckNetwork } from './networkMonitor';
import { clearSession } from './sessionPersist';

// Timeout por defecto. `process_document_image` pasa uno mucho mayor: analizar un
// PDF completo con AI tarda minutos, y abortar a los 60s dejaba la peticion
// colgada mientras el servidor seguia trabajando.
const DEFAULT_TIMEOUT_MS = 60000;

export const webserver = (method, data, callback, errCallback, timeoutMs) => {
    const fail = (err) => {
        const payload = (err && typeof err === 'object' && err.error)
            ? err
            : {
                error: true,
                message: err && err.message ? err.message : String(err),
                originalError: err,
            };
        if (typeof errCallback === 'function') {
            errCallback(payload);
            return;
        }
        if (typeof callback === 'function') callback(payload);
    };

    // Sin guarda previa de red: la petición siempre se envía. Si de verdad no hay
    // conexión, fetch falla solo y el catch reporta el error. (Antes, un sondeo
    // fallido bloqueaba aquí peticiones que sí habrían funcionado.)
    console.log('🌐 Webserver - Método:', method);
    console.log('📤 Webserver - Data:', data);
    
    //var wsUrl = "http://localhost/erp/ws/bos/" + method;
    //var wsUrl = "https://ai-bos.xyz/erp/ws/bos/" + method;
    //var wsUrl = "https://erp.ai-bos.co/api/" + method;
    var wsUrl = "https://erp.sw67.ca/ws/bos/" + method;

    console.log('🔗 Webserver - URL:', wsUrl);

    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }

    console.log('📨 Webserver - Enviando request...');

    // Timeout personalizado
    const limitMs = timeoutMs || DEFAULT_TIMEOUT_MS;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
        console.log(`⏰ Webserver - TIMEOUT tras ${limitMs / 1000} segundos`);
        controller.abort();
    }, limitMs);
    
    fetch(wsUrl, {
        ...options,
        signal: controller.signal
    })
        .then(res => {
            clearTimeout(timeoutId);
            console.log('📥 Webserver - Response status:', res.status);
            
            if (res.status === 401 || res.status === 403) {
                console.warn('🔒 Sesión inválida o token vencido. Redirigiendo a Login...');
                try {
                    clearSession();
                    if (window && window.appRouter) {
                        window.appRouter.push({ name: 'Login', params: { nextUrl: window.location.pathname } });
                    } else {
                        window.location.href = '/Login';
                    }
                } catch (e) {
                    window.location.href = '/Login';
                }
                throw new Error(`Auth Error: ${res.status} ${res.statusText}`);
            }

            if (!res.ok) {
                // index.php responde 500 con JSON {message, error_id}: mostrar eso
                // en vez de un "HTTP Error" genérico.
                return res.text().then(text => {
                    let detail = '';
                    try {
                        const body = JSON.parse(text);
                        if (body && body.message) {
                            detail = body.message + (body.error_id ? ` (${body.error_id})` : '');
                        }
                    } catch (e) { /* cuerpo no JSON */ }
                    throw new Error(detail || `HTTP Error: ${res.status} ${res.statusText}`);
                });
            }

            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                console.log('📄 Webserver - Response text length:', text.length);
                
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ Webserver - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        console.log('🔧 Webserver - JSON extraído, longitud:', jsonText.length);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            console.error('❌ Webserver - Error al parsear JSON extraído:', parseError);
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        console.error('❌ Webserver - Error al parsear JSON:', parseError);
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(response => {
            // Resumen en vez del payload completo: loguear arrays enormes (descargas
            // paginadas del catálogo) serializa y retiene miles de objetos en consola
            // y bloquea el hilo principal.
            console.log(
                '✅ Webserver - Response:',
                Array.isArray(response) ? `${response.length} registros` : response
            );
            if (response && response.error && typeof errCallback === 'function') {
                errCallback(response);
                return;
            }
            callback(response);
        })
        .catch(err => {
            clearTimeout(timeoutId);
            console.error('❌ Webserver - Error:', err);

            // Si parece un fallo de red, forzar re-chequeo para actualizar el estado
            if (err && (err.name === 'TypeError' || err.message === 'Failed to fetch' || err.name === 'AbortError')) {
                recheckNetwork();
            }

            fail({
                error: true,
                message: err.name === 'AbortError' ? 'Timeout - La operación tardó mucho tiempo' : err.message,
                originalError: err
            });
        });
}

// Wrapper Promise de `webserver` para poder hacer `await` en bucles (descarga paginada).
// Reutiliza toda la lógica de timeout/offline/parseo del `webserver` existente.
export const webserverAsync = (method, data) =>
    new Promise((resolve, reject) => {
        webserver(method, data, (res) => {
            if (res && res.error) {
                const msg = res.message
                    || (typeof res.error === 'string' ? res.error : '')
                    || 'Error de red';
                reject(new Error(msg));
            } else {
                resolve(res);
            }
        });
    });

export const fe_ws_old = (method, data, callback) => {
   //var wsUrl = "https://aipos.ngmpos.co/ws/fe_ws/" + method;
     var wsUrl = "https://ai-bos.xyz/erp/ws/fe_ws/" + method;
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    fetch(wsUrl, options)
        .then(res => {
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ FE WS Old - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(callback)
        .catch(err => console.log(err))
}


export const fe_ws = (method, data, callback) => {
    console.log('🌐 Webserver - Método:', method);
    console.log('📤 Webserver - Data:', data);
    
    //var wsUrl = "http://localhost/erp/ws/fe_ws/" + method;
    var wsUrl = "https://ai-bos.xyz/erp/ws/fe_ws/" + method;
    
    console.log('🔗 Webserver - URL:', wsUrl);
    
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    console.log('📨 Webserver - Enviando request...');
    
    // Timeout personalizado
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
        console.log('⏰ Webserver - TIMEOUT tras 30 segundos');
        controller.abort();
    }, 60000); // 30 segundos timeout
    
    fetch(wsUrl, {
        ...options,
        signal: controller.signal
    })
        .then(res => {
            clearTimeout(timeoutId);
            console.log('📥 Webserver - Response status:', res.status);
            
            if (!res.ok) {
                throw new Error(`HTTP Error: ${res.status} ${res.statusText}`);
            }
            
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                console.log('📄 FE Webserver - Response text length:', text.length);
                
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ FE Webserver - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        console.log('🔧 FE Webserver - JSON extraído, longitud:', jsonText.length);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            console.error('❌ FE Webserver - Error al parsear JSON extraído:', parseError);
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        console.error('❌ FE Webserver - Error al parsear JSON:', parseError);
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(response => {
            // Resumen en vez del payload completo: loguear arrays enormes (descargas
            // paginadas del catálogo) serializa y retiene miles de objetos en consola
            // y bloquea el hilo principal.
            console.log(
                '✅ Webserver - Response:',
                Array.isArray(response) ? `${response.length} registros` : response
            );
            callback(response);
        })
        .catch(err => {
            clearTimeout(timeoutId);
            console.error('❌ Webserver - Error:', err);
            
            // Llamar callback con error estructurado
            callback({
                error: true,
                message: err.name === 'AbortError' ? 'Timeout - La operación tardó mucho tiempo' : err.message,
                originalError: err
            });
        });
}

export const NGMGpt = (method, data, callback) => {
    var ws_server=window.location.host;
    ws_server="mi.ngmpos.co";
    var wsUrl = "https://" + ws_server + "/chatgpt/" + method;
    console.log("webserver",wsUrl);
    var strData = JSON.stringify(data);
    const options = {
        method: 'POST',
        body: strData,
        headers: {
            'Content-Type': 'application/json'
        }
    }
    fetch(wsUrl, options)
        .then(res => {
            // Obtener el texto de la respuesta para manejar warnings de PHP
            return res.text().then(text => {
                // Si el texto contiene warnings de PHP, extraer solo el JSON válido
                if (text.includes('<br />') || text.includes('<b>Warning</b>')) {
                    console.log('⚠️ NGMGpt - Detectado warning de PHP, extrayendo JSON...');
                    
                    // Buscar el primer { o [ que indica el inicio del JSON
                    const jsonStart = text.search(/[{[]/);
                    if (jsonStart !== -1) {
                        const jsonText = text.substring(jsonStart);
                        try {
                            return JSON.parse(jsonText);
                        } catch (parseError) {
                            throw new Error(`JSON Parse Error después de limpiar warnings: ${parseError.message}`);
                        }
                    } else {
                        throw new Error('No se encontró JSON válido en la respuesta con warnings');
                    }
                } else {
                    // Respuesta normal sin warnings, parsear directamente
                    try {
                        return JSON.parse(text);
                    } catch (parseError) {
                        throw new Error(`JSON Parse Error: ${parseError.message}`);
                    }
                }
            });
        })
        .then(callback)
        .catch(err => console.log(err))
}



export const getToday = () => {
    const now = new Date();
    const options = {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };
    const dateParts = now.toLocaleString('es-ES', options).split('/');
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
}

export const getIssueDate = (days) => getdays_ago(-days);

export const getdays_ago = (days) => {
    const now = new Date();
    now.setDate(now.getDate() + days); // Resta o suma días
    
    // Configuración para Madrid (España)
    const options = {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };
    
    // Formatea la fecha según la zona horaria
    const dateStr = now.toLocaleString('es-ES', options);
    const [day, month, year] = dateStr.split('/');
    
    // Devuelve en formato YYYY-MM-DD
    return `${year}-${month}-${day}`;
}

// Convierte "YYYY-MM-DD" o "YYYY-MM-DD HH:mm:ss" (o ISO con "T") en un Date en hora LOCAL.
// Evita que una fecha sin hora se interprete como medianoche UTC, lo que en Bogotá (UTC-5)
// hace que new Date("2026-09-05") se muestre como 04/09/2026.
export const parseLocalDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value) ? null : value;
    const s = String(value).trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (m) {
        return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
    }
    const d = new Date(s);
    return isNaN(d) ? null : d;
}

export const get_UUID = () => {
    var dt = new Date().getTime();
    var uuid = "xxxx-xxxx-4xxx-yxxx-xxxx".replace(/[xy]/g, function(c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}

// Importar las nuevas utilidades
import { getDefaultCurrency, getCountryLocale } from '../utils/countryUtils.js';

export const formatCurrency = (value, currency = null, options = {}) => {
    if (!value && value !== 0) return "0";

    // Obtener moneda y locale según el país de la empresa
    const finalCurrency = currency || getDefaultCurrency();
    const locale = getCountryLocale();

    // Monedas que siempre usan 2 decimales (centavos)
    const useCents = ['EUR', 'USD', 'CAD', 'GBP'].includes(finalCurrency);

    const currencyOptions = {
        style: "currency",
        currency: finalCurrency,
        minimumFractionDigits: useCents ? 2 : 0,
        maximumFractionDigits: useCents ? 2 : 2, // Max 2 decimales, pero solo si los tiene
        ...options
    };

    return new Intl.NumberFormat(locale, currencyOptions).format(value);
}

export const getStoreCurrency = () => {
    // Usar la nueva utilidad que considera el Country_IdentificationCode
    return getDefaultCurrency();
}

export const formatNumber = (value, locale = null, options = {}) => {
    if (value === null || value === undefined || isNaN(value)) return "0";
    
    // Usar locale del país actual si no se especifica
    const finalLocale = locale || getCountryLocale();
    
    const numberOptions = {
        maximumFractionDigits: 2,
        ...options
    };
    
    return new Intl.NumberFormat(finalLocale, numberOptions).format(value);
}